const flags = {
    APP_MODERNISATION: 'APP_MODERNISATION',
    FORCE_APP_MODE: 'FORCE_APP_MODE',
    ENHANCED_SEARCH : 'ENHANCED_SEARCH',
    B2C_DISABLE_AUTH: 'B2C_DISABLE_AUTH',
    ENHANCED_COUNTER: 'ENHANCED_COUNTER'
}

export default Object.freeze(flags);